import { get } from 'lodash';
import type { TSumValidatorParams } from '@ballerine/common';

import type { TValidator } from '../../types';

const validateSum = (target: number, addendsPath: number[], message: string) => {
  const sum = addendsPath.reduce((acc, curr) => acc + curr, 0);

  if (Math.round(sum) !== target) {
    throw new Error(message);
  }

  return true;
};

export const sumValueValidator: TValidator<number, TSumValidatorParams> = (
  _value,
  params,
  _schema,
  context,
) => {
  const { target, addendsPath } = params.value;

  if (!target || !Array.isArray(addendsPath) || addendsPath.length === 0) {
    throw new Error('Target and addendsPath are required.');
  }

  return validateSum(
    target,
    addendsPath.map(path => get(context, path) as number),
    params.message ?? 'The sum of values does not match the expected value.',
  );
};
